<template>
    <div class="board" v-if="displayData">
        <div class="bar">
            <b-icon icon="journal-text" class="icon"></b-icon>
            <span><slot></slot></span>
            <b-icon icon="chevron-down" class="collapse" @click="mixinsBoard_collapseContent(true)" v-if="!mixinsBoard_isShowContent"></b-icon>
            <b-icon icon="chevron-up" class="collapse" @click="mixinsBoard_collapseContent(false)" v-if="mixinsBoard_isShowContent"></b-icon>
        </div>

        <div class="content" v-show="mixinsBoard_isShowContent">
            <div class="form">
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <label>เลขที่</label>
                            <input type="text" class="input-field" :value="displayData.number" readonly />
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <label>วันที่เปิดใบงาน</label>
                            <input type="text" class="input-field" :value="displayData.openDate" readonly />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MixinThemeBoard from '@/theme/script/Board';

export default {
    mixins: [ MixinThemeBoard ],
    data() {
        return {
            displayData: null
        }
    },
    props: {
        loadData: Object  
    },
    mounted() {
        this.pageLoad();
    },
    methods: {
        pageLoad() {
            this.displayData = this.mapViewData(this.loadData);
        },
        mapViewData(data) {
            return {
                number: data ? data.number : '',
                openDate: data ? this.$AppUtility.displayTimeFormat(data.openDate) : ''
            };
        }
    }
}
</script>